<div class="overview-container" appUserManual [userManualKey]="'vendor-user-assignments-overview'">
  <div class="overview">
    <h2>Overview</h2>
  </div>
  <div class="overview-content-wrapper">
    <div class="suppliers">
      <app-deletion-list
        [items]="selectedVendorUsers"
        [displayProperties]="['userName', 'name']"
        (remove)="removeSupplier($event)"
      ></app-deletion-list>
    </div>
  </div>
  <div class="packages card mat-elevation-z2">
    <table mat-table [dataSource]="selectedAssignments" class="mat-elevation-z2 white-surface">
      <ng-container matColumnDef="#">
        <th mat-header-cell *matHeaderCellDef>#</th>
        <td mat-cell *matCellDef="let assignment; let i = index">
          {{ i + 1 }}
        </td>
      </ng-container>
      <!-- Tag Number Column -->
      <ng-container matColumnDef="procurementPackageNumber">
        <th mat-header-cell *matHeaderCellDef>Procurement Package</th>
        <td mat-cell *matCellDef="let assignment">{{ assignment.procurementPackageNumber }}</td>
      </ng-container>

      <ng-container matColumnDef="commissioningPackageNumber">
        <th mat-header-cell *matHeaderCellDef>CommPkg</th>
        <td mat-cell *matCellDef="let assignment">{{ assignment.commissioningPackageNumber }}</td>
      </ng-container>

      <ng-container matColumnDef="mcPackageNumber">
        <th mat-header-cell *matHeaderCellDef>McPackage</th>
        <td mat-cell *matCellDef="let assignment">{{ assignment.mcPackageNumber }}</td>
      </ng-container>

      <ng-container matColumnDef="tagNumber">
        <th mat-header-cell *matHeaderCellDef>Tag Number</th>
        <td mat-cell *matCellDef="let assignment">{{ assignment.tagNumber }}</td>
      </ng-container>

      <!-- Company Number Column -->
      <ng-container matColumnDef="companyNumber">
        <th mat-header-cell *matHeaderCellDef>Company Number</th>
        <td mat-cell *matCellDef="let assignment">{{ assignment.companyNumber }}</td>
      </ng-container>

      <ng-container matColumnDef="phaseNumber">
        <th mat-header-cell *matHeaderCellDef>Phase</th>
        <td mat-cell *matCellDef="let assignment">{{ assignment.phaseNumber }}</td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let assignment"><app-status-circle [status]="assignment.status"></app-status-circle></td>
      </ng-container>

      <!-- Header and Row Definitions -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; let i = index; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
